export const lottieAnimation = ()=> {

}